import { useQuery } from 'react-query';
import { useDimension } from 'hooks';
import { FEATURE_FLAGS, useConfigMatch } from 'modules/taboola-common-frontend-modules/account-configurations';
import { usePermissions } from 'modules/taboola-common-frontend-modules/authentication/hooks/usePermissions';
import { useRecommendationsApi } from 'services/api/recommendationsApi';
import { CAMPAIGN_DIMENSION } from 'services/campaignDimension';
import { PERFORMANCE_RECOMMENDATIONS } from '../config';

export const useRibbonRecommendation = (accountId, campaignId) => {
    const recommendationsApi = useRecommendationsApi();
    const isAllowed = usePermissions('PERFORMANCE_RECOMMENDATIONS_RIBBON');
    const isPermitted = !!(isAllowed && accountId);
    const isConfigured = useConfigMatch({
        [FEATURE_FLAGS.ENABLE_RIBBON_RECOMMENDATION]: 'true',
    });
    const { CAMPAIGN_UNDERPERFORMING, CAMPAIGN_LOSING_AUCTIONS } = PERFORMANCE_RECOMMENDATIONS;

    const [dimension] = useDimension();
    const { data: { results: activeAndAppliedRecommendations = [] } = {}, isLoading } = useQuery(
        [accountId, campaignId, 'recommendations', 'ribbon'],
        () => {
            if (dimension === CAMPAIGN_DIMENSION.SPONSORED) {
                const recommendationTypes = [CAMPAIGN_UNDERPERFORMING, CAMPAIGN_LOSING_AUCTIONS];
                return recommendationsApi.getSyndicatorRecommendations(accountId, recommendationTypes);
            }
            return [];
        },
        {
            enabled: !!(isPermitted && isConfigured),
            refetchOnWindowFocus: false,
        }
    );

    const ribbonRecommendations = activeAndAppliedRecommendations.filter(
        recommendation => recommendation.usedTimeUtc === null
    );

    return {
        ribbonRecommendations,
        isLoading,
    };
};
